export const DEFAULT_PERSIST_INTERVAL = 500;
export const STORAGE_KEY = 'cc-persisted-state';
